import { REPLAY_VIDEO_URL } from "../lib/replayCopy";

export const ReplayPlayer = () => (
  <div className="replay-player mx-auto w-full" style={{ maxWidth: 960, boxShadow: "0 24px 60px -18px rgba(0,0,0,0.6)" }} data-testid="replay-player">
    <iframe
      src={REPLAY_VIDEO_URL}
      frameBorder="0"
      allowFullScreen
      allow="autoplay; fullscreen; picture-in-picture"
      title="The VA Home-Ready Blueprint — Webinar Replay"
      style={{ position: "absolute", inset: 0, width: "100%", height: "100%" }}
      data-testid="replay-video-iframe"
    />
  </div>
);
